import styled from 'styled-components';

export const PageDraggableBlockWrapper = styled.div<{ isDragging: boolean; }>`
  cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};
  &:empty {
    display: none;
  }
`;
